export const contactUsResponsesActions = {
    SET_RESPONSES: 'SET_RESPONSES'
};

const contactusreducer = (state, action) => {
    switch (action.type) {
        case contactUsResponsesActions.SET_RESPONSES:
            return {
                ...state,
                resList: action.resList,
            };
        default:
            return {
                state
            };
    }
};

export default contactusreducer;